export default __webpack_public_path__ + "static/media/Ocean reef4.acd6ec3b.jpg";